import { useSearchParams } from 'react-router-dom';

export function useImpersonatedStateKey() {
  const [searchParams] = useSearchParams();

  return searchParams.get('state_key');
}
